export const familyList: RequiemRecord[][] = [
  [
    {line_1: 'Агарков Константин', line_2: 'Сергеевич', age: '8 лет'},
    {line_1: 'Агаркова Мария', line_2: 'Сергеевна', age: '10 лет'},
    {line_1: 'Агаркова Надежда', line_2: 'Васильевна', age: '57 лет'},
    {line_1: 'Алимова Ульяна', line_2: 'Дмитриевна', age: '6 лет'},
  ],
  [{line_1: 'Алимова Яна', line_2: 'Владимировна', age: '42 года'}],
  [{line_1: 'Ананьева Ксения', line_2: 'Александровна', age: '11 лет'}],
  [
    {line_1: 'Архипенко Виктория', line_2: 'Станиславовна', age: '5 лет'},
    {line_1: 'Архипенко Станислав', line_2: 'Игоревич', age: '31 год'},
  ],
  [
    {line_1: 'Баранов Артем', line_2: 'Дмитриевич', age: '12 лет'},
    {line_1: 'Баранова Арина', line_2: 'Дмитриевна', age: '8 лет'},
    {line_1: 'Баранова Марина', line_2: 'Ивановна', age: '60 лет'},
  ],
  [
    {line_1: 'Бахаев Вячеслав', line_2: 'Владимирович', age: '43 года'},
    {line_1: 'Бахаева Анна', line_2: 'Вячеславовна', age: '8 лет'},
    {line_1: 'Бахаева Ирина', line_2: 'Владимировна', age: '44 года'},
  ],
  [
    {line_1: 'Востриков Артем', line_2: 'Игоревич', age: '5 лет'},
    {line_1: 'Востриков Роман', line_2: 'Игоревич', age: '2 года'},
    {line_1: 'Вострикова Анна', line_2: 'Игоревна', age: '7 лет'},
    {line_1: 'Вострикова Елена', line_2: 'Сергеевна', age: '30 лет'},
  ],
  [
    {line_1: 'Галанин Дмитрий', line_2: 'Саркисович', age: '43 года'},
    {line_1: 'Галанин Михаил', line_2: 'Дмитриевич', age: '9 лет'},
  ],
  [{line_1: 'Дарсалия Татьяна', line_2: 'Викторовна', age: '37 лет'}],
  [{line_1: 'Ерохина Майя', line_2: 'Антоновна', age: '11 лет'}],
  [{line_1: 'Зипунова Виктория', line_2: 'Константиновна', age: '11 лет'}],
  [{line_1: 'Иванчик Артемий', line_2: 'Анатольевич', age: '9 лет'}],
  [
    {line_1: 'Каган Александр', line_2: 'Григорьевич', age: '11 лет'},
    {line_1: 'Каган Григорий', line_2: 'Александрович', age: '42 года'},
  ],
  [{line_1: 'Кляйн Анфиса', line_2: 'Викторовна', age: '30 лет'}],
  [
    {line_1: 'Ковалевская Светлана', line_2: 'Эдуардовна', age: '5 лет'},
    {line_1: 'Ковалевский Егор', line_2: 'Эдуардович', age: '9 лет'},
  ],
  [{line_1: 'Курчевская Татьяна', line_2: 'Александровна', age: '11 лет'}],
  [{line_1: 'Лиллевяли Валерия', line_2: 'Александровна', age: '5 лет'}],
  [{line_1: 'Мельникова Евгения', line_2: 'Геннадьевна', age: '45 лет'}],
  [
    {line_1: 'Мороз Мария', line_2: 'Витальевна', age: '13 лет'},
    {line_1: 'Мороз Полина', line_2: 'Сергеевна', age: '35 лет'},
  ],
  [
    {line_1: 'Москаленко Евгений', line_2: 'Вячеславович', age: '34 года'},
    {line_1: 'Москаленко Ксения', line_2: 'Евгеньевна', age: '4 года'},
    {line_1: 'Москаленко Олеся', line_2: 'Александровна', age: '37 лет'},
  ],
  [
    {line_1: 'Мухин Антон', line_2: 'Григорьевич', age: '28 лет'},
    {line_1: 'Мухин Ратибор', line_2: 'Антонович', age: '5 лет'},
  ],
  [{line_1: 'Никулин Вячеслав', line_2: 'Андреевич', age: '10 лет'}],
  [{line_1: 'Понушкова Вероника', line_2: 'Андреевна', age: '11 лет'}],
  [{line_1: 'Почанкина Виктория', line_2: 'Александровна', age: '11 лет'}],
  [
    {line_1: 'Сабадаш Алена', line_2: 'Игоревна', age: '22 года'},
    {line_1: 'Сараева Дарья', line_2: 'Петровна', age: '12 лет'},
  ],
  [{line_1: 'Селезень Наталья', line_2: 'Александровна', age: '38 лет'}],
  [
    {line_1: 'Сидоров Денис', line_2: 'Петрович', age: '39 лет'},
    {line_1: 'Сидоров Егор', line_2: 'Денисович', age: '15 лет'},
    {line_1: 'Сидорова Арина', line_2: 'Денисовна', age: '9 лет'},
  ],
  [{line_1: 'Смирнова Анастасия', line_2: 'Александровна', age: '11 лет'}],
  [{line_1: 'Сухозад Нина', line_2: 'Ивановна', age: '68 лет'}],
  [{line_1: 'Сыпко Елизавета', line_2: 'Александровна', age: '12 лет'}],
  [
    {line_1: 'Тесленко Арина', line_2: 'Игоревна', age: '8 лет'},
    {line_1: 'Тесленко Игорь', line_2: 'Юрьевич', age: '51 год'}
  ],
  [
    {line_1: 'Трусова Василиса', line_2: 'Михайловна', age: '5 лет'},
    {line_1: 'Трусова Вероника', line_2: 'Михайловна', age: '8 лет'}
  ],
  [
    {line_1: 'Устинова Наталья', line_2: 'Николаевна', age: '35 лет'},
    {line_1: 'Устинова Ульяна', line_2: 'Станиславовна', age: '4 года'}
  ],
  [{line_1: 'Федина Ольга', line_2: 'Владимировна', age: '45 лет'}],
  [{line_1: 'Черникова Вилена', line_2: 'Сергеевна', age: '11 лет'}],
  [{line_1: 'Чмыхалов Вадим', line_2: 'Олегович', age: '11 лет'}],
];

export interface RequiemRecord {
  line_1: string,
  line_2: string,
  age: string
}

export function getRandomFamilyList():RequiemRecord[] {
  let returnData:RequiemRecord[] = [];
  familyList.sort((a,b)=>Math.random() - 0.5).forEach(arr=>{
    returnData = returnData.concat(arr);
  });
  return returnData;
}